import { Trans } from '@lingui/react/macro';

interface Props {
  brandName: string;
  logoUrl?: string;
}

export const ServicesDeliveredBy = ({ brandName, logoUrl }: Props) => (
  <div className='mt-4 flex justify-between gap-2'>
    <span className='text-muted-foreground'>
      <Trans>Services are delivered by</Trans>
    </span>
    {!!logoUrl && (
      <div className='w-20 shrink-0'>
        <img src={logoUrl} alt={brandName} />
      </div>
    )}
  </div>
);
